import { CountryType } from './country';
import { LoginInfoApi } from 'graphql/generated';

export enum CustomerPageType {
    profile,
    edit,
    orders,
    points,
    exchange,
    vouchers,
    watchDog,
    favorite,
    b2bOrders,
    b2bDocuments,
}

export type DeliveryAddressType = {
    uuid: string;
    companyName: string;
    companyName2: string;
    sapId: string;
    street: string;
    city: string;
    postcode: string;
    telephone: string;
    email: string;
    firstName: string;
    lastName: string;
    country: string;
    manager: ManagerType | null;
};

export type CompanyType = {
    companyName: string | null;
    companyName2: string | null;
    sapId: string | null;
};

export type CustomerCardType = {
    number: string;
    pin: string;
    barcodeImageUrl: string;
};

export type CurrentCustomerType = {
    uuid: string;
    companyCustomer: boolean;
    firstName: string;
    lastName: string;
    email: string;
    telephone: string;
    birthDay: Date | null;
    street: string;
    city: string;
    postcode: string;
    country: CountryType;
    companyName: string;
    companyName2: string;
    companyNumber: string;
    companyTaxNumber: string;
    companyTaxIdNumber: string;
    companyEmail: string;
    companyTelephone: string;
    passwordOld: string;
    passwordFirst: string;
    passwordSecond: string;
    deliveryAddresses: DeliveryAddressType[];
    defaultDeliveryAddress: DeliveryAddressType | null;
    pricingGroup: string;
    pillCounts: PillCountsType;
    customerCards: CustomerCardType[];
    codDisabled: boolean;
    loginInfo: LoginInfoApi;
    quickContact: string | null;
    sapId: string;
    b2bPermissions: CustomerUserPermissionType;
};

type CustomerUserPermissionType = {
    orderDocumentsPage: boolean;
};

export type PillCountsType = {
    watchDogItems: number;
};

export type ManagerType = {
    sapId: string;
    fullName: string;
    email: string | null;
    telephone: string | null;
};
